/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log('[SW] App sendo servido pelo Service Worker.')
    },
    registered (registration) {
      console.log('[SW] Service Worker registrado com sucesso.')
      // Expõe globalmente para que o App.vue possa forçar verificações periódicas
      window.__swRegistration = registration
    },
    cached () {
      console.log('[SW] Conteúdo armazenado em cache para uso offline.')
    },
    updatefound () {
      console.log('[SW] Nova versão encontrada, baixando...')
    },
    updated (registration) {
      console.log('[SW] Nova versão disponível!')
      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: registration })
      )
    },
    offline () {
      console.log('[SW] Sem conexão. O app está rodando em modo offline.')
    },
    error (error) {
      console.error('[SW] Erro durante o registro:', error)
    }
  })
}
